function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { createPlugin } from '@fullcalendar/core/index.js';
import { DateTime, Duration } from 'luxon';
import { CalendarImpl, NamedTimeZoneImpl } from '@fullcalendar/core/internal.js';
function toLuxonDateTime(date, calendar) {
  if (!(calendar instanceof CalendarImpl)) {
    throw new Error('must supply a CalendarApi instance');
  }
  var _calendar$getCurrentD = calendar.getCurrentData(),
    dateEnv = _calendar$getCurrentD.dateEnv;
  return DateTime.fromJSDate(date, {
    zone: dateEnv.timeZone,
    locale: dateEnv.locale.codes[0]
  });
}
function toLuxonDuration(duration, calendar) {
  if (!(calendar instanceof CalendarImpl)) {
    throw new Error('must supply a CalendarApi instance');
  }
  var _calendar$getCurrentD2 = calendar.getCurrentData(),
    dateEnv = _calendar$getCurrentD2.dateEnv;
  return Duration.fromObject(duration, {
    locale: dateEnv.locale.codes[0]
  });
}
// Internal Utils
function luxonToArray(datetime) {
  return [datetime.year, datetime.month - 1, datetime.day, datetime.hour, datetime.minute, datetime.second, datetime.millisecond];
}
function arrayToLuxon(arr, timeZone, locale) {
  return DateTime.fromObject({
    year: arr[0],
    month: arr[1] + 1,
    day: arr[2],
    hour: arr[3],
    minute: arr[4],
    second: arr[5],
    millisecond: arr[6]
  }, {
    locale: locale,
    zone: timeZone
  });
}
var LuxonNamedTimeZone = /*#__PURE__*/function (_NamedTimeZoneImpl) {
  function LuxonNamedTimeZone() {
    _classCallCheck(this, LuxonNamedTimeZone);
    return _callSuper(this, LuxonNamedTimeZone, arguments);
  }
  _inherits(LuxonNamedTimeZone, _NamedTimeZoneImpl);
  return _createClass(LuxonNamedTimeZone, [{
    key: "offsetForArray",
    value: function offsetForArray(a) {
      return arrayToLuxon(a, this.timeZoneName).offset;
    }
  }, {
    key: "timestampToArray",
    value: function timestampToArray(ms) {
      return luxonToArray(DateTime.fromMillis(ms, {
        zone: this.timeZoneName
      }));
    }
  }]);
}(NamedTimeZoneImpl);
function formatWithCmdStr(cmdStr, arg) {
  var cmd = parseCmdStr(cmdStr);
  if (arg.end) {
    var start = arrayToLuxon(arg.start.array, arg.timeZone, arg.localeCodes[0]);
    var end = arrayToLuxon(arg.end.array, arg.timeZone, arg.localeCodes[0]);
    return formatRange(cmd, start.toFormat.bind(start), end.toFormat.bind(end), arg.defaultSeparator);
  }
  return arrayToLuxon(arg.date.array, arg.timeZone, arg.localeCodes[0]).toFormat(cmd.whole);
}
function parseCmdStr(cmdStr) {
  var parts = cmdStr.match(/^(.*?)\{(.*)\}(.*)$/); // TODO: lookbehinds for escape characters
  if (parts) {
    var middle = parseCmdStr(parts[2]);
    return {
      head: parts[1],
      middle: middle,
      tail: parts[3],
      whole: parts[1] + middle.whole + parts[3]
    };
  }
  return {
    head: null,
    middle: null,
    tail: null,
    whole: cmdStr
  };
}
function formatRange(cmd, formatStart, formatEnd, separator) {
  if (cmd.middle) {
    var startHead = formatStart(cmd.head);
    var startMiddle = formatRange(cmd.middle, formatStart, formatEnd, separator);
    var startTail = formatStart(cmd.tail);
    var endHead = formatEnd(cmd.head);
    var endMiddle = formatRange(cmd.middle, formatStart, formatEnd, separator);
    var endTail = formatEnd(cmd.tail);
    if (startHead === endHead && startTail === endTail) {
      return startHead + (startMiddle === endMiddle ? startMiddle : startMiddle + separator + endMiddle) + startTail;
    }
  }
  var startWhole = formatStart(cmd.whole);
  var endWhole = formatEnd(cmd.whole);
  if (startWhole === endWhole) {
    return startWhole;
  }
  return startWhole + separator + endWhole;
}
var index = createPlugin({
  name: '@fullcalendar/luxon3',
  cmdFormatter: formatWithCmdStr,
  namedTimeZonedImpl: LuxonNamedTimeZone
});
export { index as default, toLuxonDateTime, toLuxonDuration };